export const STORAGE_PAGE_INDEX = 'Storage/Index'
export const STORAGE_PAGE_SCAN = 'Storage/Scan'
export const STORAGE_PAGE_FACIAL = 'Storage/Facial'

export default [
  {
    path: '/storage',
    component: () => import('@/modules/storage/pages/storage'),
    meta: {
      showNavbar: true,
      title: 'Guarda Volumes',
      label: 'Guarda Volumes',
      roles: ['Admin', 'Master', 'Operator']
    },
    children: [
      {
        name: STORAGE_PAGE_INDEX,
        path: '',
        component: () => import('@/modules/storage/pages/index/index'),
        meta: {
          roles: ['Admin', 'Master', 'Operator']
        }
      },
      {
        name: STORAGE_PAGE_SCAN,
        path: 'scan',
        component: () => import('@/modules/storage/pages/scan/scan'),
        meta: {
          roles: ['Admin', 'Master', 'Operator']
        }
      },
      {
        name: STORAGE_PAGE_FACIAL,
        path: 'facial',
        component: () => import('@/modules/storage/pages/facial/facial'),
        meta: {
          roles: ['Admin', 'Master', 'Operator']
        }
      }
    ]
  }
]
